import React, { Component } from 'react'
import CommonHeader from '../../navbars/CommonHeader';

// Analysis page header: the shared CommonHeader, in a colour of its own
// (page styles from .timeanalysis-nav).
class TimeAnalysisNavbar extends Component {
    render() {
        return (
            <CommonHeader className="timeanalysis-nav" color="auto" tone="light" container={false} onToggleSidebar={this.props.onClick} title={"Time Analysis"} />
        )
    }
}

export default TimeAnalysisNavbar;
